let nextUniqueId = 0;
export function getNextUniqueId() {
    return nextUniqueId++;
}

//# sourceMappingURL=getNextUniqueId.mjs.map